// extracted by css-extract-rspack-plugin
export default {"JoinStrategyIcon":"JoinStrategyPicker-module__JoinStrategyIcon___vY9CR","JoinStrategyList":"JoinStrategyPicker-module__JoinStrategyList___JstFS"};